import { DOCUMENT } from '@angular/common';
import { Component, HostBinding, HostListener, Inject, OnInit, ViewContainerRef } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from "app/admin/shared/services/config/config.service";
import { PreloaderService } from "app/admin/shared/services/preloader/preloader.service";
import { SpinnerService } from "app/admin/shared/services/spinner/spinner.service";
import { filter, map, mergeMap } from 'rxjs/operators';
import { ThemesService } from './admin/shared/services/themes/themes.service';

@Component({
	selector: "pcode-root",
	template: "<router-outlet></router-outlet>"
})

export class AppComponent implements OnInit
{
	//App Left Sidebar Menu Open/Close Desktop
	@HostBinding("class.app_sidebar-menu-collapsed")
	get isAppSidebarLeftCollapsed()
	{
		return this.config.appLayout.isAppSidebarLeftCollapsed;
	}

	//Left Menu Sidebar Open/Close Tablet & Mobile
	@HostBinding("class.app_sidebar-left-open")
	get isAppMobileSidebarLeftOpen()
	{
		return this.config.appLayout.isAppMobileSidebarLeftOpen;
	}

	//App Right Sidebar Open/Close
	@HostBinding("class.sidebar-overlay-open")
	get isAppSidebarRightOpen()
	{
		return this.config.appLayout.isAppSidebarRightOpen;
	}

	//The constructor is called first time before the ngOnInit()
	//The constructor should only be used to initialize class members but shouldn't do actual "work".
	//So you should use constructor() to setup Dependency Injection and not much else.
	constructor
		(
			public config: ConfigService,
			public viewRef: ViewContainerRef,
			private spinner: SpinnerService,
			private titleService: Title,
			private activatedRoute: ActivatedRoute,
			private router: Router,
			private themesService: ThemesService,
			private translateService: TranslateService,
			@Inject(DOCUMENT) private document: Document
		)
	{
		// this language will be used as a fallback when a translation isn't found in the current language
		translateService.setDefaultLang('it');

		// get user lang from localstorage
		const userLanguage = localStorage.getItem('user_lang') || 'it';

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translateService.use(userLanguage);
	}

	public setTitle(newTitle: string)
	{
		this.titleService.setTitle(newTitle);
	}

	//called after the constructor and called  after the first ngOnChanges()
	//ngOnInit() is better place to "start" - it's where/when components' bindings are resolved.
	ngOnInit()
	{
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map((route) =>
				{
					while (route.firstChild) route = route.firstChild;
					return route;
				}),
				filter((route) => route.outlet === 'primary'),
				mergeMap((route) => route.data)
			)
			.subscribe((event) =>
			{
				this.translateService.get(event['title']).subscribe((translated: string) =>
				{
					/*if (this.router.url.startsWith('/web'))*/
					this.titleService.setTitle(translated + ' - Project4U')
				});
			});

		this.router.events.subscribe((evt) =>
		{
			if (!(evt instanceof NavigationEnd))
			{
				return;
			}
			this.document.body.scrollTop = 0;
		});
	}

	//check if menu should reset on resize
	@HostListener("window:resize")
	public onWindowResize(): void
	{
		if (this.shouldMenuReset())
		{
			this.config.appLayout.isAppSidebarLeftCollapsed = false;
		}
	}

	private shouldMenuReset(): boolean
	{
		return window.innerWidth <= this.config.breakpoint.desktopLG;
	}

	public ngAfterViewInit(): void
	{
		PreloaderService.load().then(() =>
		{
			this.spinner.hide();
		});
	}
}
